<script setup lang="ts">
import {useColors} from "@/composables/colors";

const { randomColor } = useColors();

interface Props {
    id: number;
    title: string;
}

const props = defineProps<Props>();
</script>

<template>
    <v-avatar
        variant="flat"
        rounded="lg"
        size="32"
        :color="randomColor(props.id)"
    >
        <span class="font-weight-medium">
            {{ props.title.charAt(0).toUpperCase() }}
        </span>
    </v-avatar>
</template>

<style scoped>

</style>
